import React, { useMemo, useCallback, useState } from "react";

// import OrderItemsTableRow from "./OrderItemsTableRow"; // legacy table row (kept for reference)
import OrderItemCard from "./OrderItemCard";
import { ImageCarousel } from "./ImageCarousel";
// MUI
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const OrderItemsTable = ({
  type,
  order,
  person,
  items,
  wardrobeItems,
  staffRequest,
  backendLineNoMap = {},
  basketLines = [],
  control,
  setValue,
  getFieldState,
  clearErrors,
  watch,
  handleSubmit,
  resetField,
  singleColumn = false,
  orderType = "draft",
}) => {
  const [openImageCarousel, setOpenImageCarousel] = useState(false);
  const [imageCarouselProduct, setImageCarouselProduct] = useState("");

  // Handle Product Image Click
  const handleImageClick = (value) => {
    setOpenImageCarousel(true);
    setImageCarouselProduct(value);
  };

  // Handle Image Carousel Close
  const handleClose = () => {
    setOpenImageCarousel(false);
  };

  const memoizedWardrobeItems = useMemo(() => wardrobeItems, [wardrobeItems]);
  const memoizedPerson = useMemo(() => person, [person]);
  const memoizedOrder = useMemo(() => order, [order]);
  const memoizedHandleImageClick = useCallback(handleImageClick, [
    handleImageClick,
  ]);

  return (
    // If the type = Accessory, paper should have a different background color that works in both light and dark mode
    <Paper
      sx={
        type === "Accessory"
          ? (theme) => ({
              backgroundColor: theme.palette.grey[200],
              ...theme.applyStyles("dark", {
                backgroundColor: theme.palette.grey[800],
              }),
            })
          : { backgroundColor: "inherit" }
      }
    >
      {!staffRequest && (
        <Typography variant="subtitle1" sx={{ p: 2, pb: 0 }}>
          {type} Items - {person.uniform}
        </Typography>
      )}

      <Grid
        container
        spacing={2}
        sx={{ p: { xs: 1.5, md: 2 }, alignItems: "stretch" }}
      >
        {memoizedWardrobeItems?.map((item) => {
          const backendLineNo = backendLineNoMap[item.productCode];
          return (
            <Grid
              key={item.productCode}
              sx={{ display: "flex" }}
              size={{
                xs: 12,
                lg: singleColumn ? 12 : 6,
                xl: singleColumn ? 12 : 4,
              }}
            >
              <OrderItemCard
                itemLineKey={item.productCode}
                backendLineNo={backendLineNo}
                basketLines={basketLines}
                item={item}
                person={memoizedPerson}
                order={memoizedOrder}
                staffRequest={staffRequest}
                handleImageClick={memoizedHandleImageClick}
                control={control}
                setValue={setValue}
                getFieldState={getFieldState}
                clearErrors={clearErrors}
                watch={watch}
                handleSubmit={handleSubmit}
                resetField={resetField}
                singleColumn={singleColumn}
                orderType={orderType}
              />
            </Grid>
          );
        })}
      </Grid>
      <ImageCarousel
        open={openImageCarousel}
        productCode={imageCarouselProduct}
        handleClose={handleClose}
      />
    </Paper>
  );
};

export default React.memo(OrderItemsTable);
